import React from 'react';
import { makeStyles, CardLegacy } from '@applyboard/ui-components';
import EligibilityInfoMobile from "../EligibilityInfo/Mobile";
import EditActions from "../EligibilityInfo/components/EditActions";
var useStyles = makeStyles({
  card: {
    padding: 0,
    margin: 0,
    width: '100%'
  }
});
var MobileContent = function MobileContent(_ref) {
  var result = _ref.result,
    program = _ref.program,
    searchData = _ref.searchData;
  var classes = useStyles();
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(CardLegacy, {
    className: classes.card,
    variant: "outlined"
  }, /*#__PURE__*/React.createElement(EligibilityInfoMobile, {
    result: result,
    program: program,
    searchData: searchData
  })), /*#__PURE__*/React.createElement(EditActions, {
    isMobile: true
  }));
};
export default MobileContent;